import React from "react";
import { Card } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";

function CountboxPage (props) {
  const navigate = useNavigate();
  return (
        <div
        className={
           props?.className
        }
        onClick={() =>
          navigate(
            props?.navigate
          )
        }
      >
        <Card className={props?.cardName}>
          <Card.Body>
            <label className="icons">
              <LazyLoadImage src={props?.image} alt={""} />
            </label>
            <span>
              <div className={"cout"}>
                {props?.count?props?.count:0}
              </div>
              <label>
                {props?.label}
              </label>
            </span>
          </Card.Body>
        </Card>
      </div>
    )
}
export default CountboxPage;